<template>
    <v-container fluid>
        <ListaConstancias :getParams="this.params"></ListaConstancias>
    </v-container>
</template>

<script>
const ListaConstancias = () => import("./components/ListaConstancias.vue");

export default {
    name: "MisCursosConstancias",
    data() {
        return {
            loading: true,
            params: {
                aprobado: true,
            }
        }
    },
    components: {
        ListaConstancias
    },
    methods: {},
    created() {

    }
}
</script>

<style>

</style>
